export default __webpack_public_path__ + "static/media/show-perfume-1.3c742eea.webp";